import React from 'react';
import {CircularProgress, Button, Chip, Typography, Stack} from '@mui/joy';
import {CardActionArea, Card, CardContent} from "@mui/joy";

import BaseApi from "../../utils/BaseApi";
import CommonActionModal from "../Common/CommonActionModal";
import withRouter from "../../utils/withRouter";
import CommonForm from "../Common/CommonForm";

// icons
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';

class EmployeeDismissModal extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: PersonRemoveIcon,
            buttonLabel: 'Уволить',
            buttonColor: 'danger',
            ready: true,
        })
    }

    async beforeModalOpen() {
        let formFields = [
            {
                name: 'end_date',
                label: 'Дата увольнения',
                type: 'date',
                default: new Date().toISOString().split('T')[0],
                xs: 12
            },
            {
                type: 'submit',
                label: 'Подтвердить увольнение'
            }
        ];

        return {
            modalLabel: 'Увольнение сотрудника',
            modalIcon: PersonRemoveIcon,
            mainComponent: CommonForm,
            mainComponentProps: {
                fields: formFields,
                processForm: this.processForm.bind(this),
            }
        };
    }

    async processForm(form) {
        const api = new BaseApi();
        const url = `employee/${this.props.params.employeeId}/dismiss/`;
        try {
            let formDataObj = Object.fromEntries(
                form.state.formData.entries()
            );
            await api.post(url, formDataObj);
            this.setModalOpenFalse();
            this.props.callBack && this.props.callBack();
        } catch (e) {
            console.error(e);
        }
    }
}

class EmployeeDetailHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            employee: props.employee || null,
            ready: !!props.employee
        };
    }

    async componentDidMount() {
        if (!this.state.employee) {
            await this.retrieveEmployee();
        }
    }

    async retrieveEmployee() {
        this.setState({ employee: null });
        const api = new BaseApi();
        const url = `employee/${this.props.params.employeeId}/`;
        try {
            const response = await api.get(url, {});
            this.setState({
                employee: response.data,
                ready: true
            });
            if (this.props.callBack) this.props.callBack();
        } catch (error) {
            console.error("Error retrieving employee", error);
            this.setState({ ready: false });
        }
    }

    render() {
        if (!this.state.ready) {
            return <CircularProgress size="sm"/>;
        }

        const emp = this.state.employee;
        if (!emp) return null;

        const getCategoryLabel = (cat) => {
            const map = {
                'ENGR': 'Инженер',
                'PROG': 'Программист',
                'MARK': 'Маркетолог',
                'ACCO': 'Бухгалтер',
                'SALE': 'Продажник',
                'MANR': 'Руководитель'
            };
            return map[cat] || cat;
        };

        const isArchived = emp.archived;

        return (
            <Card variant="outlined" sx={{width: '100%'}}>
                <CardContent sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
                    <Typography level="h3">
                        {emp.last_name} {emp.first_name} {emp.patronymic}
                    </Typography>
                    <Stack direction="row" spacing={1} useFlexGap>
                        <Chip color={isArchived ? 'danger' : 'success'} variant="solid" size="sm">
                            {isArchived ? 'В архиве' : 'Активный'}
                        </Chip>
                        <Chip size="sm" variant="soft" color="warning">
                            {getCategoryLabel(emp.category)}
                        </Chip>
                    </Stack>

                    {isArchived ? (
                        <Typography level="body-sm" color="danger">
                            Сотрудник уволен или деактивирован
                        </Typography>
                    ) : (
                        <Stack direction="row" spacing={1}>
                            <EmployeeDismissModal
                                params={{employeeId: emp.id}}
                                callBack={() => this.retrieveEmployee()}
                                overlay={false}
                            />
                        </Stack>
                    )}
                </CardContent>
            </Card>
        );
    }
}

export default withRouter(EmployeeDetailHeader);